module.exports = __webpack_public_path__ + "static/00026.f118764f.jpg";